import React, { useEffect, useState } from "react";
import { Footer } from "antd/lib/layout/layout";
import { Col, message, Row, Skeleton, Space, Typography } from "antd";
import {
  EnvironmentOutlined,
  FacebookOutlined,
  InstagramOutlined,
  LinkedinOutlined,
  MailOutlined,
  PhoneOutlined,
  TwitterOutlined,
} from "@ant-design/icons";
import Get from "../../services/Get";

const LandingFooter = () => {
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(false);

  const getContent = () => {
    setLoading(true);
    Get.getPageContent("")
      .then((res) => {
        console.log(res);
        if (res.data) {
          setPages(res.data);
        }
      })
      .catch((err) => {
        message.error(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getContent();
  }, []);

  return (
    <Footer
      style={{
        textAlign: "center",
        backgroundColor: "#f9f9f9",
        padding: "20px 20px",
        borderTop: "1px solid #e8e8e8",
      }}
    >
      <Row
        justify="center"
        align="middle"
        gutter={[16, 16]} // Adds spacing between rows for responsiveness
        style={{ rowGap: "20px" }} // Extra gap for smaller screens
      >
        {/* Social Media Links */}
        <Col xs={24} sm={24} md={24} lg={6}>
          <Row justify="center">
            <Space size="large" className="footer-social-icons">
              <Typography.Link href="https://www.facebook.com" target="_blank">
                <FacebookOutlined style={{ fontSize: 20 }} />
              </Typography.Link>
              <Typography.Link href="https://www.twitter.com" target="_blank">
                <TwitterOutlined style={{ fontSize: 20 }} />
              </Typography.Link>
              <Typography.Link href="https://www.instagram.com" target="_blank">
                <InstagramOutlined style={{ fontSize: 20 }} />
              </Typography.Link>
              <Typography.Link href="https://www.linkedin.com" target="_blank">
                <LinkedinOutlined style={{ fontSize: 20 }} />
              </Typography.Link>
            </Space>
          </Row>
        </Col>

        {/* Footer Links */}
        <Col xs={24} sm={24} md={24} lg={12}>
          <Row gutter={[16, 16]}>
            {/* Left Column - Pages */}
            <Col xs={24} sm={12}>
              <Space
                size="middle"
                className="footer-links"
                style={{ textAlign: "left", flexWrap: "wrap", gap: "10px" }}
              >
                {loading
                  ? ["", "", "", ""].map((_, index) => (
                      <Skeleton.Input key={index} active={true} size="small" />
                    ))
                  : pages.map((page) => (
                      <Typography.Link key={page.type} href={`/${page.type}`}>
                        {page.title}
                      </Typography.Link>
                    ))}
                <Typography.Link href="/contact-us">Contact Us</Typography.Link>
              </Space>
            </Col>

            {/* Right Column - Contact Details */}
            <Col xs={24} sm={12} style={{ textAlign: "left" }}>
              <Row>
                <Col span={24}>
                  <MailOutlined
                    style={{ color: "#a6cc43", marginRight: "8px" }}
                  />
                  rebatedekho.services@gmail.com
                </Col>
                <Col span={24}>
                  <PhoneOutlined
                    style={{ color: "#a6cc43", marginRight: "8px" }}
                  />
                  +91-7240700044
                </Col>
                <Col span={24}>
                  <EnvironmentOutlined
                    style={{ color: "#a6cc43", marginRight: "8px" }}
                  />
                  SA-312, Urbana Jewels, Muhana Mandi, <br></br><span style={{marginLeft: '20px'}}>Jaipur, India, 302029</span>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>

      {/* Copyright Text */}
      <Typography.Text
        style={{ display: "block", marginTop: 20, fontSize: "14px" }}
      >
        ©{new Date().getFullYear()} RebateDekho. All rights reserved.
      </Typography.Text>
    </Footer>
  );
};

export default LandingFooter;
